import script from "./UsuariosCuadres.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuariosCuadres.vue?vue&type=script&setup=true&lang=js"

import "./UsuariosCuadres.vue?vue&type=style&index=0&id=4ab60556&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ab60556"]])

export default __exports__